<template>
  <v-dialog
    v-model="show" 
    max-width="530px">
    <v-card>
      <v-card-title class="fibl-headline dialog-text pa-5">
        {{ $t('deleteDialog.title') }}
      </v-card-title>
    <v-card-text class="pa-5 dialog-text">
        {{$t('deleteDialog.text1')}}
        <b>{{getProjectName()}}</b>
        {{$t('deleteDialog.text2')}}
    </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn 
          text 
          @click="close(false)" 
          class="button__secondary"
        >
        {{ $t('deleteDialog.btnFalse') }}
        </v-btn>
        <v-btn 
          text
          class="button__primary" 
          @click="close(true)"
          >
          {{ $t('deleteDialog.btnTrue') }}
        </v-btn>
        <v-spacer> </v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteDialog",

  props: ["visible", "project"],

  data () {
    return {
      name: null
    }
  },

 computed: {

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDelete");
        }
      },
    },
  },
    
  methods: {

    close(deleteProject) {
      if (deleteProject) {
        this.$store.dispatch("removeProject", this.project);
        this.$store.dispatch("fetchProjects");
      }
      this.show = false;
    },

    getProjectName() {
      if(this.project) {
        return this.project.name;
      } else {
        return ""
      }
    }
  }

  
};
</script>
